import * as R from 'ramda';

//  获取自定义数据：logo  footer
export const getCustomData = data => {
  if (!data) return null;
  const displayInfo = R.pathOr({}, ['jsonData', 'customizedDisplayInfo'])(data);
  const custom = R.pathOr({}, ['custom'])(displayInfo);
  return custom;
}